module.exports = __webpack_public_path__ + "static/media/background.80778838.svg";